var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 89,
    height: 108,
    viewBox: "0 0 89 108",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_113_205)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.2485 28.5236C36.8509 32.266 35.8002 37.8948 29.0093 41.1564C24.2375 43.4487 24.3061 47.1053 26.3084 51.4861C30.5175 60.6996 36.8372 68.2088 44.2442 74.9524C48.168 78.5248 51.7442 78.1037 56.2598 75.5465C63.0415 71.7031 84.738 79.1327 87.9679 86.1596C90.4705 91.6031 88.1479 96.2489 83.9999 99.8887C73.6282 108.992 61.884 110.179 49.5726 104.718C31.0528 96.5046 20.4997 80.3102 10.4971 63.926C5.33031 55.4643 1.73737 46.1146 0.378582 36.1232C-1.45144 22.6651 3.39202 11.8362 14.0641 3.82472C23.995 -3.62936 32.7196 0.120649 34.6411 12.3767C35.3289 16.7622 35.5409 21.2227 36.2485 28.5252V28.5236Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_113_205"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 89,
    height: 108,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/Phone.6fa809d5e77a890918d6c60baadf9218.svg";
export { ForwardRef as ReactComponent };